export const PENDING_TO_RETURN = 'PENDING_TO_RETURN';
export const PENDING_TO_RETURN_SUCCESSFUL = 'PENDING_TO_RETURN_SUCCESSFUL';
export const PENDING_TO_RETURN_FAILED = 'PENDING_TO_RETURN_FAILED';



